import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8rem;
  width: 100%;
  justify-content: space-between;
  height: 4rem;
  position: absolute;
  bottom: 0;
  z-index: 0;
  background: #FFF;
  border-top: 1px solid var(--gray-200);
  #images-start {
    display: flex;
    gap: 1rem;
    &:first-child {
      margin-left: 1rem;
    }
    img {
      max-width: 100px;
      height: 35px;
    }
  }

  #text-middle {
    padding: 0 2rem 0 4rem;
    font-size: .7rem;
    line-height: 1.5;
    width: 70%;
    max-height: 3rem;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  @media (max-width: 850px) {
    display: none;

  }
`;
